import { render, staticRenderFns } from "./TopicCategory.vue?vue&type=template&id=7f1c3ac4&scoped=true&"
import script from "./TopicCategory.vue?vue&type=script&lang=js&"
export * from "./TopicCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1c3ac4",
  null
  
)

export default component.exports